<ng-container #dynamicContainer>
    <ng-template #template let-data="data" let-arrowOffset="arrowOffset">
        <div class="c-pop__wrapper"
             [ngClass]="customWrapperClass">
            <ng-container *ngTemplateOutlet="dynamicTemplate; context: { data: data }"></ng-container>
            <ng-content *ngIf="!dynamic"></ng-content>
            <div #customArrow
                 class="c-pop__arrow" [ngClass]="arrowClass"
                 *ngIf="arrow"></div>
        </div>
    </ng-template>
</ng-container>
